export default __webpack_public_path__ + "static/media/single_conv_hybrid_topology_full.ea919b6d.png";